module.exports = __webpack_public_path__ + "static/img/ruletka-on.ab95baac.png";